import { classNames } from "helpers/ClassNameHelper";
import React, { useContext } from "react";
import { AccessibilityContext } from "views/AccessibilityContext";

interface Props {
  left: React.ReactNode;
  right: React.ReactNode;
}

export const InfoBox: React.FC<Props> = ({ left, right }) => {
  const { lowVision } = useContext(AccessibilityContext);

  return (
    <div className={classNames("info-box", lowVision && "low-vision-darkgray")}>
      <div className="info-box-left">{left}</div>
      <span className="info-box-right">{right}</span>
    </div>
  );
};
